<template>
  <div id="app">
    <div class="container fluid mt-5">
      <div class="columns" v-if="isAuthenticated">
        <div class="column is-3">
          <SideBar />
        </div>
        <div class="column is-9">
          <router-view />
        </div>
      </div>
      <div class="columns" v-if="!isAuthenticated && isAuthentication">
        <div class="column">
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from "@/components/SideBar.vue";
export default {
  components: {
    SideBar
  },
  data() {
    return {
      isAuthenticated: false,
      isAuthentication: false,
      loader: null
    };
  },
  mounted() {
    this.loader = this.$buefy.loading.open();
    this.$emitter.on("auth.changed", () => {
      if (this.$auth.user) {
        this.isAuthenticated = true;
        this.isAuthentication = false;
      } else {
        this.isAuthenticated = false;
        this.isAuthentication = true;
        if (this.$route.name !== "auth") {
          this.$router.push({ name: "auth" });
        }
      }
      if (this.loader) {
        this.loader.close();
        this.loader = null;
      }
    });
    this.$auth.authenticate();
  }
};
</script>

<style lang="scss">
@import "./assets/scss/buefy.scss";
@import "./assets/scss/app.scss";
</style>
